import _ from "lodash";
import ArrayToTree from "array-to-tree";
import {
  computed,
  defineComponent,
  onMounted,
  PropType,
  reactive,
  Ref,
  toRefs,
  watch,
  ref,
} from "vue";
import { DepartmentService } from "@/views/organization/department/department.service";
import { DeptRecord, TreeNode } from "./department-select.interface";
import { useEventbus } from "@/core";
import { Form } from "ant-design-vue";
import {onMountedOrActivated} from   "@/core/hooks/onMountedOrActivated"

interface IState {
  visible: boolean;
  loading: boolean;
  userSearchId: string | undefined;
  records: TreeNode[];
  treeData: TreeNode[];
  expandedKeys: string[];
  tempDepts: DeptRecord[];
  selectedDepts: DeptRecord[];
  innerMaxCount: Ref<number>;
  selectedDeptIds: Ref<string[]>;
  dataMap: object;
  // isError: boolean;
}

/**
 * 部门选择器
 *
 * <department-select v-model:value="formRef.departmentIds"></department-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "DepartmentSelect",
  props: {
    // props.multiple 为 true 时, value 为 string[]
    // props.multiple 为 false 时, value 为 string
    value: {
      type: [String, Array] as PropType<string | string[]>,
      default: "",
    },

    // 是否展示员工列表
    showDeptList: { type: Boolean, default: true },

    // 是否禁用
    disabled: { type: Boolean, default: false },
    // 是否有劳务班组
    staffType: { type: [String], default: 'no_type' },

    // 是否多选
    multiple: { type: Boolean, default: false },

    // 最多选择多少个部门
    maxCount: { type: Number, default: 1 },
    formName: { type: Array, default: () => [] },
  },
  emits: ["update:value", "change", "select","update:idStr"],
  setup(props, { emit }) {
    const formItemContext = Form.useInjectFormItemContext();
    const state = reactive<IState>({
      visible: false,
      loading: false,
      userSearchId: undefined,
      records: [],
      treeData: [],
      expandedKeys: [],
      tempDepts: [],
      selectedDepts: [],
      innerMaxCount: computed(() => {
        return props.multiple ? props.maxCount : 1;
      }),
      selectedDeptIds: computed(() => {
        return state.selectedDepts.map((item) => item.id);
      }),
      dataMap: {},
      // isError: false,
    });
    const { run } = DepartmentService.useFullListApi();
    const { $on } = useEventbus();
    let isError = ref(false);
    const showModal = async () => {
      state.userSearchId=undefined;
      if (props.disabled) {
        return;
      }
      const res = await run({staffType:props.staffType});
      if (res.respCode === "0000") {
        state.records = res.data?.records || [];
        state.expandedKeys = state.records.map((item) => item.id);
        state.records.forEach((o) => {
          o.name = o.name.substring(0, 20);
        });
        state.treeData = ArrayToTree(state.records, {
          parentProperty: "parentId",
          customID: "id",
        });
      }
      state.visible = true;
    };

    const initDataMap = async()=>{
      const res = await run({staffType:props.staffType});
      if (res.respCode === "0000") {
        state.records = res.data?.records || [];
        state.expandedKeys = state.records.map((item) => item.id);
        state.treeData = ArrayToTree(state.records, {
          parentProperty: "parentId",
          customID: "id",
        });
        state.dataMap = state.records.reduce((p, n) => {
          if (!p[n.id]) {
            p[n.id] = n;
          }
          return p;
        }, {});
        // console.log(state.dataMap,'state.dataMap----htl')
      }
      // console.log("state.treeData", state.treeData);
    }
    onMountedOrActivated(async () => {
      // console.log('onMountedOrActivated1')
      // console.log(props.value,'props.value++++++')
      state.selectedDepts=[];
      await initDataMap();

      valueChange(props.value)
    })
    const valueChange = (pn) => {
      // console.log("🚀 ~ file: department-select.controller.ts:136 ~ valueChange ~ pn", pn)
      if (typeof pn === "string") {
        state.dataMap[pn] ? state.selectedDepts.push(state.dataMap[pn]) : "";
      } else {
        (pn as any).map((v) => {
          if (state.dataMap[v]) {
            state.selectedDepts.push(state.dataMap[v]);
          }
        });
      }
      // console.log("🚀 ~ file: department-select.controller.ts:145 ~ valueChange ~  state.selectedDepts",  state.selectedDepts)

      state.selectedDepts = _.uniqBy(state.selectedDepts, "id");
      // console.log("🚀 ~ file: department-select.controller.ts:146 ~ valueChange ~  state.selectedDepts",  state.selectedDepts)
      state.tempDepts = _.cloneDeep(state.selectedDepts);
    }
    const isWatch = ref(true);
    watch(()=>props.value,(pn)=>{
      valueChange(pn)
          // if (typeof pn === "string") {
          //   state.dataMap[pn] ? state.selectedDepts.push(state.dataMap[pn]) : "";
          // } else {
          //   // console.log(pn,'pn------htl',state.dataMap[pn[0]]);
          //   (pn as any).map((v) => {
          //     if (state.dataMap[v]) {
          //       state.selectedDepts.push(state.dataMap[v]);
          //     }
          //   });
          //   // console.log(state.selectedDepts,'state.selectedDepts--------htl')
          // }
          // state.selectedDepts = _.uniqBy(state.selectedDepts, "id");
          // state.tempDepts = _.cloneDeep(state.selectedDepts);
    },{deep:true})
    // watch(
    //   [() => props.value, () => state.dataMap],
    //  async ([pn, sn], [po, so]) => {
    //       await initDataMap();
    //     // console.log("valueNew----", pn, "valueOld----", po,isWatch.value);
    //     // // console.log("dataMapNew----", sn, "dataMapOld----", so);
    //     if (pn && sn && isWatch.value) {
    //       if (typeof pn === "string") {
    //         state.dataMap[pn] ? state.selectedDepts.push(state.dataMap[pn]) : "";
    //       } else {
    //         (pn as any).map((v) => {
    //           if (state.dataMap[v]) {
    //             state.selectedDepts.push(state.dataMap[v]);
    //           }
    //         });
    //       }
    //       state.selectedDepts = _.uniqBy(state.selectedDepts, "id");
    //       state.tempDepts = _.cloneDeep(state.selectedDepts);
    //       // console.log("state.selectedDepts", state.selectedDepts);
    //     } else if (!pn && sn) {
    //       state.selectedDepts = [];
    //     }
    //   },
    //   { immediate: true, deep: true }
    // );

    const closeModal = () => {
      state.visible = false;
      state.tempDepts = [];
      state.expandedKeys = [];
      state.treeData = [];
    };
    $on("form-error", (data) => {
      if (props.formName.length && data.length) {
        let nameString = props.formName.join(",");
        for (let i = 0; i < data.length; i++) {
          let errorString =
            typeof data[i]["name"] == "string" ? data[i]["name"] : data[i]["name"].join(",");
          if (errorString === nameString) {
            isError.value = true;
            break;
          } else {
            isError.value = false;
          }
        }
      }
    });
    const triggerUpdate = () => {
      const ids = state.selectedDeptIds;
      // console.log(props.multiple,'props.multiple')
      // console.log(ids,'idsidsids')
      if (ids.length === 0) {
        isError.value = true;
        emit("update:value", props.multiple ? [] : "");
        emit("change", state.selectedDepts);
        emit("update:idStr", props.multiple ?'': ids[0])
      } else {
        isError.value = false;
        emit("update:value", props.multiple ? ids : ids[0]);
        emit("change", state.selectedDepts);
        emit("update:idStr", props.multiple ? ids.join(",") : ids[0])
      }
    };

    const ok = () => {
      state.selectedDepts = _.cloneDeep(state.tempDepts);
      emit("select", state.selectedDepts);
      triggerUpdate();
      isWatch.value = false;
      if (state.selectedDepts.length > 0) {
        isError.value = false;
      }
      closeModal();
      formItemContext.onFieldChange();
    };

    const addTempDept = (selectedKeys, { node }) => {
      if (state.innerMaxCount && state.tempDepts.length >= state.innerMaxCount) {
        return;
      }
      const tempDeptIds = state.tempDepts.map((item) => item.id);
      const { id, name } = node.dataRef;
      if (!tempDeptIds.includes(id)) {
        state.tempDepts.push({ id, name });
      }
    };

    const deleteTempDept = (deletedId) => {
      state.tempDepts = state.tempDepts.filter((item) => item.id !== deletedId);
    };

    const deleteSelectedDept = (deletedId) => {
      state.selectedDepts = state.selectedDepts.filter((item) => item.id !== deletedId);
      state.tempDepts = _.cloneDeep(state.selectedDepts);
      isWatch.value = false;
      triggerUpdate();
    };

    const onDeptTreeSelect = (dept) => {
      const { id, name } = dept;
      const tempDeptIds = state.tempDepts.map((item) => item.id);
      if (!tempDeptIds.includes(id)) {
        state.tempDepts.push({ id, name });
      }
    };

    return {
      ...toRefs(state),
      showModal,
      closeModal,
      ok,
      addTempDept,
      deleteTempDept,
      deleteSelectedDept,
      onDeptTreeSelect,
      isError,
    };
  },
});
